var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "elevation-12"
  }, [_c('v-toolbar', {
    staticStyle: {
      "height": "60px"
    },
    attrs: {
      "dark": "",
      "color": "primary",
      "height": "60"
    }
  }, [_c('img', {
    attrs: {
      "src": "/img/atlas-mobile.png",
      "alt": "avatar"
    }
  }), _c('v-spacer')], 1), _c('v-card-text', [_c('v-alert', {
    attrs: {
      "value": _vm.invalidCredentials,
      "color": "error"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$vuetify.t('$vuetify.app.invalidCredentials')) + "\n    ")]), _c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    nativeOn: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.submit.apply(null, arguments);
      }
    },
    model: {
      value: _vm.valid,
      callback: function callback($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    staticClass: "login",
    attrs: {
      "prepend-icon": "person",
      "name": "login",
      "label": "Login",
      "type": "text",
      "rules": _vm.loginRules,
      "required": ""
    },
    model: {
      value: _vm.data.username,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "username", $$v);
      },
      expression: "data.username"
    }
  }), _c('v-text-field', {
    staticClass: "password",
    attrs: {
      "id": "password",
      "prepend-icon": "lock",
      "name": "password",
      "label": "Password",
      "type": "password",
      "rules": _vm.passwordRules,
      "required": ""
    },
    model: {
      value: _vm.data.password,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "password", $$v);
      },
      expression: "data.password"
    }
  })], 1)], 1), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "loading": _vm.loading,
      "dark": "",
      "block": "",
      "disabled": !_vm.valid,
      "name": "loginButton"
    },
    on: {
      "click": function click($event) {
        return _vm.submit();
      }
    }
  }, [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.app.login')) + "\n        ")])], 1), _c('v-flex', {
    staticClass: "text-xs-center pt-4 pb-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('router-link', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "to": "/password/email"
    }
  }, [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.app.forgotPassword')))])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }